import { fetchCarrier } from '@/api/business/carrier'
import { useQuery } from '@tanstack/react-query'

export const CarrierKeys = {
    all: ['carrier'] as const,
    lists: () => [...CarrierKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...CarrierKeys.lists(), page, perPage, filters] as const,
    details: () => [...CarrierKeys.all, 'detail'] as const,
    detail: (params: string) => [...CarrierKeys.details(), params] as const,
}

export const useCarrierQuery = () => {
    return useQuery({
        queryFn: fetchCarrier,
        queryKey: CarrierKeys.lists(),
    })
}
